<!--
 * @Descripttion: 
 * @version: 
 * @Author: Sam
 * @Date: 2020-05-11 15:24:36
 * @LastEditors: Sam
 * @LastEditTime: 2020-08-21 08:53:11
-->
<template>
  <div class="share-container">
    <div class="share-main">
      <div class="hd">共享试卷返学贝</div>
      <div class="bd">
        <p class="lovely-warning">将您组好的试卷在平台中共享给其它老师参考学习，赠人玫瑰，手留余香。</p>
        <el-form :model="paper" :rules="rules" ref="shareForm" :hide-required-asterisk="true" label-width="75px">
          <el-form-item label="试卷标题:" prop="title">
            <el-input v-model="paper.title" maxlength="100" minlength="10"></el-input>
            <p class="title-tips">标题需包含试卷的学段+学科+版本+册别+考试用途等，不少于10个字</p>
          </el-form-item>
          <el-form-item label="试卷简介:" prop="desc">
            <el-input type="textarea" resize="none" placeholder="简单描述试卷的出题思路，知识点，难易程度，适用范围等" minlength="10" maxlength="200" v-model="paper.desc"></el-input>
          </el-form-item>
          <el-form-item label="试卷类型:" prop="zone">
            <el-select v-model="paper.zone" placeholder="请选择" @change="zoneChange">
              <el-option v-for="item in zones" :key="item.value" :label="item.name" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <div class="form-item-wrap" v-if="isTb">
            <el-form-item label="版本册别:" prop="versionBook">
              <el-cascader :options="versionsAndBooks" :props="$data.$props" v-model="paper.versionBook" @change="versionBookChange" popper-class="jx-cascader-options"></el-cascader>
            </el-form-item>
            <el-form-item label="章节:" prop="chapter">
              <el-cascader :options="chapters" v-model="paper.chapter" :props="props" popper-class="jx-cascader-options"></el-cascader>
            </el-form-item>
          </div>
          <div class="form-item-wrap" v-else>
            <el-form-item label="教材版本:" prop="bookVersion">
              <el-select v-model="paper.bookVersion" placeholder="请选择">
                <el-option v-for="item in versions" :key="item.value" :label="item.name" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="册别:" prop="book">
              <el-select v-model="paper.book" placeholder="请选择">
                <el-option v-for="item in books" :key="item.value" :label="item.name" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="form-item-wrap"> 
            <el-form-item label="地区:" prop="area">
              <el-cascader :options="areas" v-model="paper.area" placeholder="请选择" popper-class="jx-cascader-options"></el-cascader>
            </el-form-item>
            <el-form-item label="年份:" prop="year">
              <el-select v-model="paper.year" placeholder="请选择">
                <el-option v-for="(item, key) in years" :key="key" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
          </div>
          <el-form-item>
            <div class="share-now" @click="shareNow">立即共享</div>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
var that
import * as util from '../utils/util.js'
import { $BASE_URL } from '../utils/env'
import areas from '../utils/area'
import axios from 'axios'
export default {
  name: 'share',
  data() {
    return {
      stage: '',
      subject: '',
      paperId: '',
      isTb: true,
      zones: [
        {
          name: '同步备课',
          value: 0
        }
      ],
      versionsAndBooks: [],
      chapters: [],
      books: [],
      versions: [],
      areas: areas,
      years: [],
      paper: {
        title: '',
        desc: '',
        zone: '',
        versionBook: [],
        chapter: [],
        bookVersion: '',
        book: '',
        area: [],
        year: ''
      },
      props:{
        label: 'name',
      },
      $props: {
        lazy: true,
        label: 'name',
        async lazyLoad(node, resolve) {
          if (node && node.level == 1) {
              let data = {
                _keys: 'book',
                stage: that.stage,
                subject: that.subject,
                version: node.value
              }
              let res = await axios.get(`${$BASE_URL}/documents/filters`, { params: data })
              let options = res.data.data[0].options
              options.forEach(item => {
                item.leaf = true
              })
              resolve(options)
          }
        },
      },
      rules: {
          title: [
            { required: true, message: '请输入试卷标题', trigger: 'blur' },
            { min: 10, max: 100, message: '标题长度在10~100之间', trigger: 'blur' }
          ],
          desc: [
            { required: true, message: '请输入试卷简介', trigger: 'blur' },
            { min: 10, max: 200, message: '简介长度在10~200之间', trigger: 'blur' }
          ],
          zone: [
            { required: true, message: '请选择试卷类型', trigger: 'change' }
          ],
          versionBook: [
            { required: true, message: '请选择版本册别', trigger: 'change' }
          ],
          chapter: [
            { required: true, message: '请选择章节', trigger: 'change' }
          ],
          bookVersion: [
            { required: true, message: '请选择教材版本', trigger: 'change' }
          ],
          book: [
            { required: true, message: '请选择册别', trigger: 'change' }
          ],
          area: [
            { required: true, message: '请选择地区', trigger: 'change' }
          ],
          year: [
            { required: true, message: '请选择年份', trigger: 'change' }
          ]
      }
    }
  },
  created() {
    that = this
    if(Object.keys(this.$route.query).length) {
      that.stage = this.$route.query.stage_id
      that.subject = this.$route.query.subject_id
      that.paperId = this.$route.query.paper_id
      that.getZonesList()
    }
    that.getYear()
  },
  methods:{
    getTreeData(data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].children.length < 1) {
          delete data[i].children
        } else {
          that.getTreeData(data[i].children)
        }
      }
      return data
    },
    getYear() {
      let date = new Date()
      let year = date.getFullYear()
      that.paper.year = year
      let list = [year + 1, year, year - 1, year - 2, year - 3]
      that.years = list
    },
    filters(data,cb) {
      axios.get(`${$BASE_URL}/documents/filters`,{
        params: data
      }).then(res => {
        if(res.status == 200) {
          cb && cb(res.data.data)
        } 
      })
    },
    getZonesList() {
      let data = {
        _keys: 'version',
        is_zone: 1,
        stage: that.stage,
        subject: that.subject
      }
      that.filters(data,(data) => {
        that.zones = [...that.zones,...data[0].options]
      })
    },
    getTbVersions() {
      let data = {
        _keys: 'version',
        stage: that.stage,
        subject: that.subject
      }
      that.filters(data,(data) => {
        that.versionsAndBooks = data[0].options
      })
    },
    getBooksAndBookVersions(value) {
      let data = {
        _keys: 'book,book_version',
        stage: that.stage,
        subject: that.subject,
        version: value
      }
      that.filters(data,(data) => {
        that.books = data[1].options
        that.versions = data[0].options
      })
    },
    zoneChange(value) {
      if(value != 0) {
        that.isTb = false
        that.getBooksAndBookVersions(value)
      }else{
        that.isTb = true
        that.getTbVersions()
      }
    },
    versionBookChange(value) {
      let data = {
        _keys: 'chapter',
        stage: that.stage,
        subject: that.subject,
        version: value[0],
        book: value[1]
      }
      that.filters(data,(data) => {
        that.chapters = that.getTreeData(data[0].options)
      })
    },
    shareNow() {
      this.$refs['shareForm'].validate(async (valid) => {
        if (valid) {
          let data = {
            id: that.paperId,
            title: that.paper.title,
            intro: that.paper.desc,
            year: that.paper.year,
            province_id: that.paper.area[0]
          }
          if(this.isTb) {
            data.version_id = that.paper.versionBook[0]
            data.book_id = that.paper.versionBook[1]
            data.chapter_id = that.paper.chapter[that.paper.chapter.length - 1]
          }else{
            data.version_id = that.paper.zone
            data.book_id = that.paper.book
            data.book_version_id = that.paper.bookVersion
          }
          axios.defaults.withCredentials = true
          axios.post(`${$BASE_URL}/papers/share`, data).then(res => {
            let data = res.data
            if(data.code == 0) {
              this.$router.push({
                path: '/paperFrontend/shareSuccess',
                query: {
                  coins: data.data.coin
                }
              })
            }else{
              util.showTips(data.msg)
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.share-container {
  width: 100%;
  padding-top: 20px;
  .share-main {
    margin: 0 auto;
    padding: 0 10px;
    width: 1200px;
    min-width: 1200px;
    background-color: #fff;
    .hd {
      height: 50px;
      line-height: 50px;
      text-align: center;
      
      border-bottom: 1px solid #eee;
    }
    .bd {
      width: 100%;
      padding-bottom: 60px;
      .lovely-warning {
        width: 500px;
        font-size: 12px;
        color: #333;
        margin: 20px auto;
      }
      .el-form {
        width: 500px;
        margin: 0 auto;
        .form-item-wrap {
          .el-form-item {
            display: inline-block;
            width: 225px;
          }
        }
        .el-form-item {
          width: 450px;
          margin-bottom: 20px;
          .title-tips {
            line-height: 14px;
            color: #f60;
            font-size: 12px;
            margin-top: 5px;
          }
          /deep/ .el-form-item__label {
            color: #666;
          }
          /deep/ .el-input__inner {
            border-radius: 2px;
            height: 36px;
            line-height: 36px;
          }
          /deep/ .el-textarea__inner {
            border-radius: 2px;
          }
          /deep/ .el-textarea__inner {
            height: 100px;
            line-height: 1.3;
          }
          /deep/ .el-select {
            width: 150px;
          }
        }
        .share-now {
          margin: 40px auto 0;
          width: 120px;
          height: 36px;
          line-height: 36px;
          text-align: center;
          padding: 0 10px;
          border-radius: 2px;
          background-color: #2b99ff;
          color: #fff;
          cursor: pointer;
          &:hover {
            background-color: #067ff3;
          }
        }
      }
    }
  }
}
</style>
